import React from 'react';

import PropTypes from 'prop-types';

import styles from './Burger.module.scss';

const Burger = ({ active, setActive }) => {
  return (
    <div
      onClick={() => setActive(!active)}
      onKeyDown={() => setActive(!active)}
      role="button"
      tabIndex="0"
      className={styles.burger}
    >
      <div className={active ? 'active' : ''} />
      <div className={active ? 'active' : ''} />
      <div className={active ? 'active' : ''} />
    </div>
  );
};

Burger.propTypes = {
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
};

export default Burger;
